import {
  Show,
  Typography,
  Tag,
  Col,
  Row,
  FileField,
  DateField,
} from "@pankod/refine-antd";
import { useOne, useShow, useTranslate } from "@pankod/refine-core";

const { Title, Text } = Typography;

export const TendersShow = () => {
  const { queryResult } = useShow();
  const { data, isLoading } = queryResult;
  const record = data?.data;
  const t = useTranslate();

  return (
    <Show isLoading={isLoading}>
      <Row gutter={20}>
        <Col xs={24} lg={16}>
          <Row gutter={10}>
            <Col xs={24} lg={12}>
              <Title level={5}>{t("tenders.fields.name")}</Title>
              <Text>{record?.name}</Text>

              <Title level={5}>{t("tenders.fields.status")}</Title>
              <Text>{t(`statusTypes.${record?.status}`)}</Text>

              <Title level={5}>{t("tenders.fields.date")}</Title>
              <DateField value={record?.startDate} format="LL" />

              <Title level={5}>{t("tenders.fields.description")}</Title>
              <Text>{record?.description}</Text>

              <Title level={5}>{t("tenders.fields.type")}</Title>
              <Text>{record?.type}</Text>

              <Title level={5}>{t("tenders.fields.file")}</Title>
              {record?.images?.map((data: any) => {
                return (
                  <Col xs={24} lg={12}>
                    <FileField
                      target="_blank"
                      title={data?.name}
                      src={data?.url}
                    />
                  </Col>
                );
              })}
            </Col>
          </Row>
        </Col>
      </Row>
    </Show>
  );
};
